import { useContext } from 'react';
import { GlobalContext } from '../utils/context.js';

var useUserInfo = function () {
    // @ts-ignore
    var userInfo = useContext(GlobalContext).userInfo;
    return userInfo;
};

export { useUserInfo as default };
